<template>
    <div class="inputs">
        <div class="input input-container">
            <label>{{ $t("settings.linkedinActionForm") }}</label>
            <input
                v-model="clone.path"
                :placeholder="$t('settings.urlPlaceholderLinkedin')"
                @input="handleLinkedinUpdate"
                no-flags
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            clone: { ...this.value },
        };
    },
    methods: {
        handleLinkedinUpdate() {
            this.$emit("input", this.clone);
        },
    },
};
</script>

<style scoped lang="scss">
.inputs {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .input-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
        position: relative;

        label {
            font-size: 12px;
            color: var(--color-text-strong-default);
        }

        input {
            border: 1px solid var(--color-border-default);
            border-radius: 5px;
            padding: 5px 10px;
            flex: 1;
            outline: none;

            &:focus {
                border: 1px solid #1999e3;
                box-shadow: 0 0 0 2px rgba(25, 153, 227, 0.2);
            }

            &.error {
                border: 1px solid red;
                box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.2);
            }
        }

        .input-cancel-icon {
            cursor: pointer;
            position: absolute;
            top: 50%;
            right: 5px;
            font-size: 16px;
            transform: translateY(-50%);
        }
    }
}
</style>
